export type TextVariant =
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "h6"
  | "eyebrow"
  | "body1"
  | "body2"
  | "body3"
  | "caption"
  | "CTALarge"
  | "CTASmall"
  | "label"

export type TextElement = "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "body1" | "p" | "span"

export const TYPOGRAPHY = {
  h1: {
    large: {
      fontSize: "90px",
      lineHeight: "95%",
      letterSpacing: "-1.8px",
    },
    medium: {
      fontSize: "72px",
      lineHeight: "95%",
      letterSpacing: "-1.44px",
    },
    small: {
      fontSize: "56px",
      lineHeight: "95%",
      letterSpacing: "-1.12px",
    },
    fontWeight: "400",
    fontFamily: "var(--font-haffer)",
  },
  h2: {
    large: {
      fontSize: "56px",
      lineHeight: "100%",
      letterSpacing: "-0.56px",
    },
    medium: {
      fontSize: "48px",
      lineHeight: "100%",
      letterSpacing: "-0.48px",
    },
    small: {
      fontSize: "40px",
      lineHeight: "100%",
      letterSpacing: "-0.40px",
    },
    fontWeight: "400",
    fontFamily: "var(--font-haffer)",
  },
  h3: {
    large: {
      fontSize: "40px",
      lineHeight: "110%",
      letterSpacing: "-0.40px",
    },
    medium: {
      fontSize: "36px",
      lineHeight: "110%",
      letterSpacing: "-0.36px",
    },
    small: {
      fontSize: "32px",
      lineHeight: "110%",
      letterSpacing: "-0.32px",
    },
    fontWeight: "400",
    fontFamily: "var(--font-haffer)",
  },
  h4: {
    large: {
      fontSize: "32px",
      lineHeight: "110%",
      letterSpacing: "0px",
    },
    medium: {
      fontSize: "28px",
      lineHeight: "110%",
      letterSpacing: "0px",
    },
    small: {
      fontSize: "24px",
      lineHeight: "100%",
      letterSpacing: "0px",
    },
    fontWeight: "400",
    fontFamily: "var(--font-haffer)",
  },
  h5: {
    large: {
      fontSize: "24px",
      lineHeight: "115%",
      letterSpacing: "0px",
    },
    medium: {
      fontSize: "20px",
      lineHeight: "115%",
      letterSpacing: "0px",
    },
    small: {
      fontSize: "20px",
      lineHeight: "120%",
      letterSpacing: "0px",
    },
    fontWeight: "400",
    fontFamily: "var(--font-haffer)",
  },
  h6: {
    large: {
      fontSize: "20px",
      lineHeight: "120%",
      letterSpacing: "0px",
    },
    medium: {
      fontSize: "18px",
      lineHeight: "120%",
      letterSpacing: "0px",
    },
    small: {
      fontSize: "16px",
      lineHeight: "120%",
      letterSpacing: "0.16px",
    },
    fontWeight: "400",
    fontFamily: "var(--font-haffer)",
  },
  eyebrow: {
    large: {
      fontSize: "13px",
      lineHeight: "100%",
      letterSpacing: "0.13px",
    },
    medium: {
      fontSize: "13px",
      lineHeight: "100%",
      letterSpacing: "0.13px",
    },
    small: {
      fontSize: "12px",
      lineHeight: "100%",
      letterSpacing: "0.12px",
    },
    fontWeight: "400",
    fontFamily: "var(--font-ibm-plex-mono)",
  },
  body1: {
    large: {
      fontSize: "16px",
      lineHeight: "140%",
      letterSpacing: "0.16px",
    },
    medium: {
      fontSize: "16px",
      lineHeight: "140%",
      letterSpacing: "0.16px",
    },
    small: {
      fontSize: "14px",
      lineHeight: "140%",
      letterSpacing: "0.14px",
    },
    fontWeight: "400",
    fontFamily: "var(--font-haffer)",
  },
  body2: {
    large: {
      fontSize: "14px",
      lineHeight: "140%",
      letterSpacing: "0.12px",
    },
    medium: {
      fontSize: "14px",
      lineHeight: "140%",
      letterSpacing: "0.12px",
    },
    small: {
      fontSize: "14px",
      lineHeight: "140%",
      letterSpacing: "0.12px",
    },
    fontWeight: "400",
    fontFamily: "var(--font-haffer)",
  },
  body3: {
    large: {
      fontSize: "12px",
      lineHeight: "140%",
      letterSpacing: "0.12px",
    },
    medium: {
      fontSize: "12px",
      lineHeight: "140%",
      letterSpacing: "0.12px",
    },
    small: {
      fontSize: "12px",
      lineHeight: "140%",
      letterSpacing: "0.12px",
    },
    fontWeight: "400",
    fontFamily: "var(--font-haffer)",
  },
  caption: {
    large: {
      fontSize: "12px",
      lineHeight: "130%",
      letterSpacing: "0.24px",
    },
    medium: {
      fontSize: "12px",
      lineHeight: "140%",
      letterSpacing: "0.24px",
    },
    small: {
      fontSize: "12px",
      lineHeight: "140%",
      letterSpacing: "0.24px",
    },
    fontWeight: "400",
    fontFamily: "var(--font-haffer)",
  },
  CTALarge: {
    large: {
      fontSize: "16px",
      lineHeight: "100%",
      letterSpacing: "0.16px",
    },
    medium: {
      fontSize: "16px",
      lineHeight: "100%",
      letterSpacing: "0.16px",
    },
    small: {
      fontSize: "16px",
      lineHeight: "100%",
      letterSpacing: "0.16px",
    },
    fontWeight: "500",
    fontFamily: "var(--font-haffer)",
  },
  CTASmall: {
    large: {
      fontSize: "14px",
      lineHeight: "100%",
      letterSpacing: "0.14px",
    },
    medium: {
      fontSize: "14px",
      lineHeight: "100%",
      letterSpacing: "0.14px",
    },
    small: {
      fontSize: "14px",
      lineHeight: "100%",
      letterSpacing: "0.14px",
    },
    fontWeight: "500",
    fontFamily: "var(--font-haffer)",
  },
  label: {
    large: {
      fontSize: "14px",
      lineHeight: "110%",
      letterSpacing: "0.14px",
    },
    medium: {
      fontSize: "14px",
      lineHeight: "110%",
      letterSpacing: "0.14px",
    },
    small: {
      fontSize: "14px",
      lineHeight: "110%",
      letterSpacing: "0.14px",
    },
    fontWeight: "400",
    fontFamily: "var(--font-haffer)",
  },
}
